export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey.length === 2:
      return splitKey[1]

    case splitKey.length === 3:
      if (splitKey[1].length === 3) return splitKey[2]
      if (splitKey[1].length === 6) return `${splitKey[1]}${splitKey[2]}`
      return splitKey[2]

    case splitKey.length === 4:
      if (splitKey[0] === 'CHOOSE') return betKey
      if (splitKey[2] === 'INDEX') return splitKey[3]
      return `${splitKey[2]}:${splitKey[3]}`

    case splitKey.length === 6:
      if (splitKey[0] === 'CHOOSE') {
        if (splitKey[1] === splitKey[3]) return `get${splitKey[1]}`
        else return `get${splitKey[1]}in${splitKey[3]}`
      }
      return `${splitKey[2]}:${splitKey[3]}`
  }
}
